import { FC, useMemo } from 'react'
import {
  Datagrid, DateField, DateInput, FunctionField, List, TextField, TextInput,
} from 'react-admin'
import { Chip } from '@mui/material'
import { AuditLogOut } from '../../types/apiRequests'
import AuditLogExpand from './AuditLogExpand'

const AuditLogList: FC = () => {
  const auditFilters = useMemo(() => [
    <TextInput key="action" source="action" label="auditLog.action" alwaysOn />,
    <TextInput key="target_type" source="target_type" label="auditLog.targetType" />,
    <TextInput key="actor_email" source="actor_email" label="auditLog.actor" />,
    <DateInput key="created_after" source="created_after" label="auditLog.createdAfter" />,
    <DateInput key="created_before" source="created_before" label="auditLog.createdBefore" />,
  ], [])

  return (
    <List
      exporter={false}
      sort={{ field: 'created', order: 'DESC' }}
      filters={auditFilters}
    >
      <Datagrid bulkActionButtons={false} rowClick="expand" expand={<AuditLogExpand />}>
        <DateField source="created" showTime label="auditLog.timestamp" />
        <TextField source="action" label="auditLog.action" />
        <TextField source="actor_email" label="auditLog.actor" />
        <TextField source="target_type" label="auditLog.targetType" />
        <TextField source="target_id" label="auditLog.targetId" />
        <FunctionField<AuditLogOut>
          label="auditLog.context"
          render={(record) => (
            <Chip
              label={Object.keys(record.context ?? {}).length}
              size="small"
              sx={{ fontWeight: 600, fontSize: 11, height: 22 }}
            />
          )}
        />
      </Datagrid>
    </List>
  )
}

export default AuditLogList
